import api from './data.services'
import { authService } from '.'

const notificationsSrv = 'notifications'

const getNotifications = async () => {
  try {
    const resp: any = await api.get(notificationsSrv, authService.getToken())

    if(resp && resp.status === 200) {
      return {
        status: 'Ok',
        data: (resp.data ? resp.data : {})
      }
    }

    return {
      status: 'Error',
      message: (resp && resp.response && resp.response.data && resp.response.data.errors ? resp.response.data.errors : '')
    }
  } catch(error: any) {
    return {
      status: 'Error',
      message: (error && error.msg ? error.msg : 'Error server obtener notificaciones')
    }
  }
}

const postNotification = async (serv: string) => {
  try {
    const resp: any = await api.getSrv(serv, authService.getToken())

    if(resp && resp.status === 200) {
      return {
        status: 'Ok',
        data: (resp.data ? resp.data : {})
      }
    }

    return {
      status: 'Error',
      message: (resp && resp.response && resp.response.data && resp.response.data.errors ? resp.response.data.errors : '')
    }
  } catch(error: any) {
    return {
      status: 'Error',
      message: (error && error.errors.length ? error.errors[0].msg : 'Error server aceptar o rechazar notificación')
    }
  }
}

export const notifyService = {
  getNotifications,
  postNotification
}